import styled from '@emotion/styled';

export const Container = styled.div<{
  width?: string;
  height?: string;
  isDisplayMGMRewardsPromoBanner?: boolean;
  flexDirection?: 'row' | 'column';
  gap?: string;
}>`
  display: flex;
  margin: auto;
  align-items: center;

  flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
  justify-content: ${({ isDisplayMGMRewardsPromoBanner }) =>
    isDisplayMGMRewardsPromoBanner ? 'space-between' : 'center'};

  gap: ${({ gap }) => gap || '0px'};

  width: ${({ isDisplayMGMRewardsPromoBanner, width }) =>
    isDisplayMGMRewardsPromoBanner ? 'min(712px, 100%)' : width || 'min(343px, 100%)'};

  height: ${({ height }) => (height === 'auto' ? 'auto' : height || 'fit-content')};
  min-height: ${({ height, isDisplayMGMRewardsPromoBanner }) =>
    height === 'auto' ? 'unset' : isDisplayMGMRewardsPromoBanner ? '400px' : '540px'};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0px;
    position: static;
    width: 100%;
    height: auto;
    min-height: unset;
  }

  > div,
  button {
    align-self: stretch;
  }
`;
